module.exports = __webpack_public_path__ + "img/screenshot_hero@2x.8e0cbcc2.png";